// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"ed3eaedf","513":"a3936ba2","703":"60561ca9","787":"90742145"}[chunkId] + ".chunk.js";
};